module.exports = __webpack_public_path__ + "img/amex.d7bccd49.svg";